export const getGtmProducts = () =>
  window.__litium.preloadState.cart.gtmProducts;

export const getCurrency = () => window.__litium.preloadState.cart.currency;

export const formatPrice = (price) => {
  const currency = getCurrency();
  return price.replace(currency, '').replace(/ /g, '');
};

const getMetaEventId = () => {
  return global['MetaEventId'];
};

export const pushEcommerce = (data) => {
  try {
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
  // Call the event callback immediately if gtm isn't initialized
  if (typeof data.eventCallback == 'function' && !isGtmInitialized()) {
    data.eventCallback();
  }
};

export const onCheckoutStep = (step, option, callback = null) => {
  const hasPushedStep =
    dataLayer.find(
      (d) =>
        d.event == 'checkout' &&
        d.ecommerce &&
        d.ecommerce.checkout.actionField.step == step
    ) != null;

  if (hasPushedStep) {
    // This step was already pushed to the data layer, push "checkoutOption" instead
    pushEcommerce({
      event: 'checkoutOption',
      ecommerce: {
        checkout_option: {
          actionField: {
            step,
            option,
          },
        },
        eventID: getMetaEventId(),
      },
      eventCallback: callback,
      eventTimeout: 200,
    });
  } else {
    pushEcommerce({
      event: 'checkout', // checkoutOption if we already pushed this step to dataLayer
      ecommerce: {
        currencyCode: getCurrency(),
        checkout: {
          actionField: {
            step,
            option,
          },
          products: getGtmProducts(),
        },
        eventID: getMetaEventId(),
      },
      eventCallback: callback,
      eventTimeout: 200,
    });
  }
};

export const dataLayerAddToCart = (ecommerce) => {
  try {
    pushEcommerce({
      event: 'gtm_add_to_cart',
      ecommerce: ecommerce,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerRemoveFromCart = (gtmEcommerceItems) => {
  try {
    pushEcommerce({
      event: 'gtm_remove_from_cart',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0]?.currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + (v.price ?? 0) * (v.quantity ?? 0),
          0
        ),
        eventID: getMetaEventId(),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerBeginCheckout = (gtmEcommerceItems) => {
  try {
    pushEcommerce({
      event: 'gtm_begin_checkout',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0]?.currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + (v.price ?? 0) * (v.quantity ?? 0),
          0
        ),
        eventID: getMetaEventId(),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerLogin = (gtmEcommerceItems) => {
  try {
    pushEcommerce({
      event: 'gtm_login',
      ecommerce: {
        eventID: getMetaEventId(),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerSelectItem = (gtmEcommerceItems) => {
  try {
    pushEcommerce({
      event: 'gtm_select_item',
      ecommerce: {
        items: gtmEcommerceItems,
        eventID: getMetaEventId(),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerSearch = (query) => {
  try {
    pushEcommerce({
      event: 'gtm_search',
      ecommerce: {
        search_term: query,
        eventID: getMetaEventId(),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const datalayerViewCart = (ecommerce) => {
  try {
    pushEcommerce({
      event: 'gtm_view_cart',
      ecommerce: ecommerce,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerSignUp = () => {
  try {
    pushEcommerce({
      event: 'gtm_sign_up',
      ecommerce: {
        eventID: getMetaEventId(),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const isGtmInitialized = () => {
  return (
    typeof dataLayer !== 'undefined' &&
    dataLayer.length > 0 &&
    dataLayer.find((d) => d.event == 'gtm.load')
  );
};
